<template>
  <div class="home_index">
    <div class="home_header">
      <Swipe
        :loop="false"
        :show-indicators="false"
        width="100%"
        height="100%"
        :touchable="false"
        ref="swipeItem"
      >
        <SwipeItem v-for="(item,index) in tabs" :key="index">
          <VanImage :src="item.imgurl" fit="cover" width="100%" height="100%">
            <template v-slot:loading>
              <loading type="spinner" size="20" />
            </template>
            <template v-slot:error>加载失败</template>
          </VanImage>
        </SwipeItem>
      </Swipe>
    </div>
    <div class="home_body">
        <template v-if="tabs.length">
            <div class="tabs" v-if="tabs.length>1">
                <div v-for="(item,index) in tabs" :key="item.id" class="tabcard" :class="{active:index===swiperIndex}" @click="switchTab(item.id,index)">
                    <span>{{item.title}}</span>
                </div>
            </div>
            <SportItem
                v-if="currentItem.id==item_id"
                :item="currentItem"
                :sports_id="sports_id"
                :detail="detail"
            ></SportItem>
            
        </template>
        <template v-else>
            <div class="tabbody">
                <!-- 暂无数据 -->
            </div>
        </template>
    </div>
    <!-- <div class="fl" @click="goqus">
        <img src="https://oss.mcloud.moveclub.cn/alphamovecloud/20220919/1663549786/366004.png"/>
    </div>      -->
  </div>
</template>
<script>
    import "./index.less"
    import SportItem from "./item";
    import { Image, Loading, Tab, Tabs, Swipe, SwipeItem } from "vant";
    export default {
        name: 'homeIndex',
        data () {
            return {
                currentItem: {},
                tabs: [],
                detail: "",
                swiperIndex: 0,
                item_id: 507,
                sports_id: 10054
            }
        },
        components:{
            VanImage: Image,
            Loading,
            Tab,
            Tabs,
            Swipe,
            SportItem,
            SwipeItem,
        },
        watch: {
            item_id(e) {
                this.itemChange();
            },
        },
        methods: {
            goqus() {
                window.location.href = 'https://oss.mcloud.moveclub.cn/alphamovecloud/20220919/1663549786/894499.pdf'
                // this.$router.push({ name: 'answer', params: { acid: process.env.VUE_APP_QUESID }})
            },
            switchTab: function (id,index) {
                this.swiperIndex = index;
                this.currentItem = this.tabs[index];
                this.$router.replace({params: {item_id: id,sports_id:this.sports_id}})
                this.$refs.swipeItem.swipeTo(index);
            },
            initIndex(){
               this.$api.wechat.jsapiConfig().then((res)=>{
               })
            },
            itemChange: function () {
                if(this.cf.isEmpty(this.item_id)){
                    this.item_id = this.tabs[0]['id']
                    this.$router.replace({params:{item_id: this.tabs[0]['id'],sports_id:this.sports_id}})
                    return ;
                }
                this.currentItem = this.tabs.filter((item) => {
                    return +item.id === +this.item_id;
                })[0];
            },
            init: function () {
                this.$toast.loading({
                    message: "加载中...",
                    forbidClick: true,
                    duration: 0, // 持续展示 toast
                });
                this.$api.sports.sportsMain({sports_id:this.sports_id}).then(
                    (res) => {
                    this.tabs = res.data.items;
                    let {
                        bgstyle,
                        id,
                        tabstyle,
                        introstyle,
                        shareconfig,
                        title,
                    } = res.data;
                    try {
                        bgstyle = JSON.parse(bgstyle);
                        tabstyle = JSON.parse(tabstyle);
                        introstyle = JSON.parse(introstyle);
                        // shareconfig = JSON.parse(shareconfig);
                    } catch (e) {
                        console.error(e);
                    }
                    this.detail = { id, bgstyle, tabstyle, introstyle, title };
                    //定义 颜色
                    // this.setBgColor(bgstyle.background);
                    // this.$storage.set("shareInfo", shareconfig);
                    this.$toast.clear();
                    this.itemChange();
                    this.$refs.swipeItem.swipeTo(this.swiperIndex);
                    if (window.__wxjs_is_wkwebview) {
                        //部分ios
                        window.scrollTo(0, 1);
                    }               
                    },
                    (e) => {
                    this.$toast.clear();
                    }
                );
            },
        },     
        mounted() {
            this.$nextTick(() => {
                // this.initIndex();
                // this.sports_id = this.$route.params.sports_id
                // this.item_id = this.$route.params.item_id
                this.init()
            })

        }
    }
</script>

